__turbopack_context__.v({
  "appear-slide-left": "ParallaxVideo-module-scss-module__q2hn9W__appear-slide-left",
  "bounceTwice": "ParallaxVideo-module-scss-module__q2hn9W__bounceTwice",
  "container": "ParallaxVideo-module-scss-module__q2hn9W__container",
  "fade-in-bottom": "ParallaxVideo-module-scss-module__q2hn9W__fade-in-bottom",
  "fade-in-left": "ParallaxVideo-module-scss-module__q2hn9W__fade-in-left",
  "fade-in-right": "ParallaxVideo-module-scss-module__q2hn9W__fade-in-right",
  "fadeIn": "ParallaxVideo-module-scss-module__q2hn9W__fadeIn",
  "loader": "ParallaxVideo-module-scss-module__q2hn9W__loader",
  "parallax": "ParallaxVideo-module-scss-module__q2hn9W__parallax",
  "puff-in-center": "ParallaxVideo-module-scss-module__q2hn9W__puff-in-center",
  "puff-in-left": "ParallaxVideo-module-scss-module__q2hn9W__puff-in-left",
  "pulse": "ParallaxVideo-module-scss-module__q2hn9W__pulse",
  "pulse-contact": "ParallaxVideo-module-scss-module__q2hn9W__pulse-contact",
  "shake-bottom": "ParallaxVideo-module-scss-module__q2hn9W__shake-bottom",
  "slide-again": "ParallaxVideo-module-scss-module__q2hn9W__slide-again",
  "slide-in-right": "ParallaxVideo-module-scss-module__q2hn9W__slide-in-right",
  "stepContent-entrance": "ParallaxVideo-module-scss-module__q2hn9W__stepContent-entrance",
  "video": "ParallaxVideo-module-scss-module__q2hn9W__video",
});
